/* eslint-disable */
// @ts-nocheck
import React from "react";
import { TabList, Tab } from "@carbon/react";
import Badge from "../../components/badge/Badge";
import { ReactComponent as CheckIcon } from "../../assets/icons/check.svg";

interface IProps {
  TABS_LIST: string[];
  activation?: "manual" | "automatic";
  ariaLabel: string;
  currentIndex?: number;
  className?: string;
  showBadge?: boolean;
  showCheckmark?: boolean;
}

export default ({
  ariaLabel,
  activation = "automatic",
  TABS_LIST,
  currentIndex,
  className,
  showBadge = true,
  showCheckmark,
}: IProps) => {
  return (
    <TabList
      aria-label={ariaLabel}
      activation={activation}
      className={className}
    >
      {TABS_LIST.map((tab, idx) => {
        return (
          <Tab data-cy={`${tab.replaceAll(" ", "")}-tab`}>
            {showCheckmark && idx == 0 ? (
              <Badge />
            ) : showBadge ? (
              <Badge badgeCounter={idx + 1} />
            ) : null}
            {tab}
          </Tab>
        );
      })}
    </TabList>
  );
};
